import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Invite API service — manages invite codes for shared courses
 */
export const InviteApi = {
  /**
   * Create a new invite code for an endeavor
   * @param {string|number} endeavorId
   * @param {Object} options
   * @param {number} [options.maxUses] - Maximum redemptions (null = unlimited)
   * @param {string} [options.expiresAt] - ISO datetime for expiry (null = never)
   * @returns {Promise<Response>} CourseInviteDTO
   */
  createInvite: async (endeavorId, options = {}) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavors/${endeavorId}/invites`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(options),
    });
  },

  /**
   * List active invites for an endeavor
   * @param {string|number} endeavorId
   * @returns {Promise<Response>} Array of CourseInviteDTO
   */
  getInvites: async (endeavorId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavors/${endeavorId}/invites`, {
      method: 'GET',
    });
  },

  /**
   * Deactivate an invite
   * @param {string|number} inviteId
   * @returns {Promise<Response>}
   */
  deactivateInvite: async (inviteId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/invites/${inviteId}`, {
      method: 'DELETE',
    });
  },

  /**
   * Validate an invite code (check if active, not expired, not maxed)
   * @param {string} code - The invite code
   * @returns {Promise<Response>} CourseInviteDTO with endeavor info
   */
  validateInvite: async (code) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/invites/${encodeURIComponent(code)}/validate`, {
      method: 'GET',
    });
  },

  /**
   * Redeem an invite code (enroll current user in the course)
   * @param {string} inviteCode
   * @returns {Promise<Response>} EnrollmentDTO
   */
  redeemInvite: async (inviteCode) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/invites/redeem`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ inviteCode }),
    });
  },
};
